export default __webpack_public_path__ + "static/media/2.89d18ee7.jpg";